import { Shark, View } from "shark-mvc";

import User from "../../models/User";

import templateContent from "./login.html";
import "./style.css";

import dashboardView from "../dashboard/dashboardView";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import registerView from "../register/registerView";
import userManager from "../../controllers/userManager";

class LoginView extends View {
	constructor() {
		super("loginView");
		
		this.$mainRoute = "login";
		this.setTemplate(templateContent);
	}

	afterLoad () {
		if (Shark.$store?.currUser?.email) {
			document.querySelector("#passwordField").focus();
		}
		else {
			document.querySelector("#emailField").focus();
		}
	}

	beforeLoad () {
		const lastUserEMail = localStorage.getItem("lastUserEMail") || "";
		const currUser = new User({email: lastUserEMail});

		currUser.set({password: ""});
		Shark.set({
			currUser,
		});
	}

	init () {
		this.addComponents([mainNavComponent]);

		Shark.set({
			passwordFieldType: "password",
			passwordFieldTypeIcon: "bi-eye-slash",
		});
	}

	inputField_keyupHandler (event) {
		if (event.keyCode === 13) {
			this.login();
		}
	}

	login () {
		const currUser = Shark.get("currUser");

		if (!currUser.isValid("login")) {
			currUser.set({
				email: document.querySelector("#emailField").value,
				password: document.querySelector("#passwordField").value,
			});
		}
		
		if (currUser.isValid("login")) {
			userManager.logIn(currUser)
			.then(loginResponse => {
				if (loginResponse.status === "ok") {
					Shark.set({
						loginError: false,
					});

					localStorage.setItem("preserveLogin", currUser.__preserveLogin);
					localStorage.setItem("lastUserEMail", currUser.email);
					Shark.openPage(dashboardView);
				}
				else {
					alert("Non hai il permesso di accedere qui...");
				}
			});
		}
		else {
			Shark.render();
		}
	}

	loginBtn_clickHandler () {
		this.login();
	}

	loginForm_submitHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		return false;
	}

	navRegisterViewBtn_clickHandler (event) {
		event.preventDefault();

		Shark.openPage(registerView);
	}

	showPasswordBtn_clickHandler () {
		Shark.set({
			passwordFieldType: Shark.$store.passwordFieldType === "password" ? "text" : "password",
			passwordFieldTypeIcon: Shark.$store.passwordFieldTypeIcon === "bi-eye-slash" ? "bi-eye" : "bi-eye-slash",
		});

		document.querySelector("#passwordField")?.focus();
	}
}

const loginView = new LoginView();

Shark.registerView(loginView);

export default loginView;
